import { render } from "./CDBIncarceration.vue?vue&type=template&id=dd35b1ea&scoped=true"
import script from "./CDBIncarceration.vue?vue&type=script&lang=js"
export * from "./CDBIncarceration.vue?vue&type=script&lang=js"

import "./CDBIncarceration.vue?vue&type=style&index=0&id=dd35b1ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd35b1ea"]])

export default __exports__